module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABKUlEQVQ4T9WSMUtCURzFf//3pEFoiIImJ1NxaIhoiNbGSNSvUBBB0NDe4lBDfYaGBrcXfYZwqiEoLAelpbagWtKn98R7UpgW2NiBO9zD+XEPh2sMSMXcFmjRgsbmkF8BPVvQOP70TYXsKj4VZEmMGWASaCIsDhlCpIAexiMiBA5NpdwTUEXUMJWRZYCDLzCGtQHeG6iKMY/YNRVzIXgLFtRvVM5ncL1ZCxoX36qWskso7FjQulYhncJLNCPwHdMLWIjkMHNAYhCMa/blx0dMRVXbOO3gu4fR/BAeXbu9aXzvpA92WbHz+8sfYiOW1vIZJtzt38FoB/07sIOzZTu7uxprnPX0HH6iHo3zimkP59dw6n+z3+SZwOUxTk2l7DawD5Yc50WgDTr6AMY1maR3RahmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/information/news_icon_ril.png
// module id = oPBL
// module chunks = 1